module.exports = __webpack_public_path__ + "static/media/universities-icon-3.6894ff3c.svg";